export const main = {
    login:'로그인',
    register:'등록',
    sy: '홈페이지',
    cpzx: "제품 센터",
    jjfa: "솔루션",
    hyyy: "산업 응용",
    fwyzc: "서비스 및 지원",
    gywm: "우리에 대해서",
    xlwjxj: "INS-CHVS 시리즈 매크로 카메라",
    ljkzq: "INS-LC-0532-001 로직 컨트롤러",
    sjkzq: "INSBOX-VSC-CM 비전 컨트롤러",
    sdxxrj: "INSAI 딥 러닝 소프트웨어",
    sjjcpt: "INS-3D 비전 검사 플랫폼",
    sjcl: "비전 측정",
    sjjc: "육안 검사",
    sjyd: "시각적 안내",
    jcsb: "AOI 테스트 장비",
    xnyld: "새로운 에너지 리튬 배터리",
    wl:'물류',
    qcyzdh:'자동차 및 자동화',
    cpsc:'제품 설명서',
    gsjs:'회사',
    lxwm:'연락'
}